import React, { useState } from 'react';
import SupportChatModal from './SupportChatModal.js';
import { trackEvent } from '../utils/bridge.js';

export default function ReportIssueButton() {
    const [showChat, setShowChat] = useState(false);
    return (
        <>
            <button
                className="fixed bottom-4 left-4 bg-gradient-to-r from-yellow-400 to-pink-600 text-white px-3 py-2 rounded"
                onClick={() => { trackEvent('support_button_clicked'); setShowChat(true); }}
            >
                Report Issue
            </button>
            <SupportChatModal visible={showChat} setVisible={setShowChat} />
        </>
    );
}
